import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Headphones02 = function Headphones02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M22 17v-4c0-5.5228-4.4772-10-10-10S2 7.4772 2 13v4m5.5 4C6.1193 21 5 19.8807 5 18.5v-3C5 14.1193 6.1193 13 7.5 13s2.5 1.1193 2.5 2.5v3c0 1.3807-1.1193 2.5-2.5 2.5m9 0c-1.3807 0-2.5-1.1193-2.5-2.5v-3c0-1.3807 1.1193-2.5 2.5-2.5s2.5 1.1193 2.5 2.5v3c0 1.3807-1.1193 2.5-2.5 2.5"
    })
  }));
};
export default Headphones02;